<template>
  <div class="contentBody">
    <div class="contentBox">
      <div class="leftBox">
        <div class="userHead">
          <div class="img">
            <img :src="$imgUrl + info.avatar" alt="" />
          </div>
          <div class="cont">
            <div class="textBox">
              <div class="name">
                {{ info.nickname ? info.nickname : info.name }}
              </div>
            </div>
            <div class="dzBox">
              <div class="box">
                <div class="iconfont icon-coordinates_fill"></div>
                <div class="name" v-if="info.province">
                  {{ info.province }} {{ info.city }} {{ info.area }}
                </div>
                <div class="name" v-else>暂无地址</div>
              </div>
              <div class="box">
                <div
                  class="iconfont icon-xinxipingtaiyeicons_qiuzuzhaozu"
                ></div>
                <div class="name">
                  {{ info.company_name ? info.company_name : "暂无信息~" }}
                </div>
              </div>
            </div>
            <div class="jjTxt c-2">
              {{ info.signature ? info.signature : "暂无介绍~" }}
            </div>
          </div>
          <div class="dzCont" v-if="addressInfo.id">
            <div class="head" @click="siteJump">
              <div class="name">收货地址</div>
              <div class="iconfont icon-enter"></div>
            </div>
            <div class="text">
              <span>默认</span>{{ addressInfo.province }}{{ addressInfo.city
              }}{{ addressInfo.area }}{{ addressInfo.address }}
            </div>
          </div>
        </div>
        <div class="wlBox" v-if="member_lengthData.orderinfo.id != 0">
          <div class="title">我的物流</div>
          <div class="cont">
            <div class="img" v-if="member_lengthData.orderinfo.order_car">
              <img
                v-if="
                  member_lengthData.orderinfo.order_car[0].part.resources[0]
                "
                :src="
                  $imgUrl +
                  member_lengthData.orderinfo.order_car[0].part.resources[0]
                    .path_name
                "
                alt=""
              />
            </div>
            <div class="box">
              <div class="name" v-if="member_lengthData.orderinfo.order_car">
                {{ member_lengthData.orderinfo.order_car[0].productname }}
              </div>
              <div
                class="text"
                v-if="member_lengthData.orderinfo.express_content"
              >
                {{
                  member_lengthData.orderinfo.express_content[
                    member_lengthData.orderinfo.express_content.length - 1
                  ].AcceptStation
                }}
              </div>
            </div>
            <div class="anniu" @click="shouhuoClick">确认收货</div>
          </div>
        </div>
        <div class="content">
          <div class="leftcontHead">
            <div class="boxs">
              <div
                class="box"
                :class="index == typeOn ? 'on' : ''"
                v-for="(item, index) in typeList"
                @click="typeClick(index)"
              >
                <div class="name">{{ item }}</div>
              </div>
            </div>
            <div class="inpBox">
              <input
                type="text"
                placeholder="请搜索您发布的内容"
                v-model="seachName"
                @keyup.enter="searchClick"
              />
              <div
                class="ssBox iconfont icon-search"
                @click="searchClick"
              ></div>
            </div>
          </div>
          <div class="contList">
            <Kong v-if="member_forumList.length == 0" />
            <div class="cont" v-for="(item, index) in member_forumList">
              <div class="contHead">
                <div class="fbBox">
                  <div class="phoimg">
                    <img :src="$imgUrl + item.memberavatar" alt="" />
                  </div>
                  <div class="name">{{ item.membername }}</div>
                  <div class="txt">论坛</div>
                </div>
                <div class="lxBox">
                  <!-- <div class="box">
                    <div class="yuan">#</div>
                    <div class="name">类型类型</div>
                  </div> -->
                  <div class="box">
                    <div class="name" @click="wzshowClick(item.id)">编辑</div>
                  </div>
                  <div class="box hongb">
                    <div class="name" @click="delClick(item.id)">删除</div>
                  </div>
                </div>
              </div>
              <div class="contTitle" @click="ltjump(item.id)">
                {{ item.name }}
              </div>
              <div class="contText c-3" @click="ltjump(item.id)">
                {{ item.content }}
              </div>
              <div class="funBox">
                <div class="boxs">
                  <div class="box">
                    <div class="iconfont icon-browse browse"></div>
                    <div class="num">{{ item.click }}</div>
                  </div>
                  <div class="box">
                    <div class="iconfont icon-message message"></div>
                    <div class="num">{{ item.childrenlength }}</div>
                  </div>
                  <div
                    class="box"
                    style="cursor: pointer"
                    @click="favoriteClick(item, index)"
                  >
                    <div
                      class="iconfont praise"
                      :class="
                        item.is_favorite ? 'icon-praise_fill on' : 'icon-praise'
                      "
                    ></div>
                    <div class="num">{{ item.praise }}</div>
                  </div>
                  <div class="box">
                    <div class="iconfont icon-send send"></div>
                    <div class="num">分享</div>
                    <div class="fxBox">
                      <div class="lianjieBox dis-cent">
                        <div class="iconfont icon-lianjie lianjie"></div>
                      </div>
                      <div class="name" @click="lianjieClick(item)">
                        复制链接
                      </div>
                    </div>
                  </div>
                </div>
                <div class="time">{{ item.create_time }}</div>
              </div>
            </div>
            <div class="fenye" v-if="totalCount > 15">
              <a-pagination
                :default-current="page.pageNo"
                v-model="page.pageNo"
                :total="totalCount"
                @change="onChange"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="ritBox1">
        <div class="content">
          <div class="contHead">
            <div class="img">
              <div class="iconfont icon-collection_fill"></div>
            </div>
            <div class="name">社区联系</div>
          </div>
          <div class="cont">
            <div class="box" @click="lxJump(0)">
              <div class="num">{{ member_lengthData.guanzhu }}</div>
              <div class="name">关注</div>
            </div>
            <div class="box" @click="lxJump(1)">
              <div class="num">{{ member_lengthData.fensi }}</div>
              <div class="name">粉丝</div>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="contHead">
            <div class="img lv">
              <div class="iconfont icon-document_fill"></div>
            </div>
            <div class="name">订单信息</div>
          </div>
          <div class="cont">
            <div class="box" @click="orderClick(0)">
              <div class="num">
                {{
                  member_lengthData.ordertotal
                    ? member_lengthData.ordertotal
                    : 0
                }}
              </div>
              <div class="name">全部订单</div>
            </div>
            <div class="box" @click="orderClick(1)">
              <div class="num">
                {{
                  member_lengthData.orderstatus1
                    ? member_lengthData.orderstatus1
                    : 0
                }}
              </div>
              <div class="name">待付款</div>
            </div>
            <div class="box" @click="orderClick(2)">
              <div class="num">
                {{
                  member_lengthData.orderstatus2
                    ? member_lengthData.orderstatus2
                    : 0
                }}
              </div>
              <div class="name">待发货</div>
            </div>
            <div class="box" @click="orderClick(3)">
              <div class="num">
                {{
                  member_lengthData.orderstatus3
                    ? member_lengthData.orderstatus3
                    : 0
                }}
              </div>
              <div class="name">已发货</div>
            </div>
            <div class="box" @click="orderClick(4)">
              <div class="num">
                {{
                  member_lengthData.orderstatus4
                    ? member_lengthData.orderstatus4
                    : 0
                }}
              </div>
              <div class="name">已完成</div>
            </div>
            <div class="box" @click="orderClick(5)">
              <div class="num">
                {{
                  member_lengthData.orderstatus5
                    ? member_lengthData.orderstatus5
                    : 0
                }}
              </div>
              <div class="name">已评价</div>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="contHead">
            <div class="img huang">
              <div class="iconfont icon-new3-7qiuzu"></div>
            </div>
            <div class="name">社区成就</div>
          </div>
          <div class="cont">
            <div class="box">
              <div class="num">
                {{ member_lengthData.pinglun ? member_lengthData.pinglun : 0 }}
              </div>
              <div class="name">评论</div>
            </div>
            <div class="box">
              <div class="num">
                {{ member_lengthData.fabu ? member_lengthData.fabu : 0 }}
              </div>
              <div class="name">发布</div>
            </div>
            <div class="box">
              <div class="num">
                {{ member_lengthData.zan ? member_lengthData.zan : 0 }}
              </div>
              <div class="name">获赞与收藏</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Shezhi v-if="szshow" @show="shezhiShowJs" />
    <a-modal v-model="shouhuovisible" title="提示" @ok="shouhuohandleOk">
      <p>是否确认收货</p>
    </a-modal>
    <Wenzhang v-if="wzshow" :id="wId" @show="wenzhangShowJs" />
    <a-modal v-model="shouwenzang" title="提示" @ok="shouwenzhangdleOk">
      <p>是否确认删除</p>
    </a-modal>
  </div>
</template>

<script>
import Shezhi from "../component/shezhi.vue";
import Kong from "../component/kong.vue";
import { Form, Space, Button, Modal } from "ant-design-vue";
import Wenzhang from "../component/wenzhang.vue";

export default {
  components: {
    Kong,
    Shezhi,
    Wenzhang,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-button": Button,
    "a-space": Space,
    "a-modal": Modal,
  },
  name: "",
  data() {
    return {
      shouwenzang: false,
      shouhuovisible: false,
      szshow: false,
      wzshow: false,
      typeOn: 0,
      typeList: ["我的论坛"],
      info: {},
      addressInfo: {},
      member_lengthData: {
        orderinfo: {
          id: 0,
        },
      },
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      member_forumList: [],
      seachName: "",
      totalCount: 0,
      wId: 0,
      ltId: 0,
    };
  },
  created() {
    this.get();
    this.address_default_get();
    this.member_lengthGet();
    this.listGet();
  },
  methods: {
    delClick(id) {
      this.ltId = id;
      this.shouwenzang = true;
    },
    shouwenzhangdleOk() {
      this.$post("/web/forum_delete", {
        id: Number(this.ltId),
      }).then((res) => {
        console.log(res);
        this.shouwenzang = false;
        if (res.data.status) {
          this.member_forumList = [];
          this.listGet();
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    wzshowClick(id) {
      this.wId = id;
      this.wzshow = true;
    },
    wenzhangShowJs(data) {
      if (data) {
        this.member_forumList = [];
        this.listGet();
      }
      this.wzshow = false;
    },
    onChange(pageNumber) {
      this.member_forumList = [];
      this.page.pageNo = pageNumber;
      this.listGet();
    },
    favoriteClick(item, i) {
      this.$post("/web/favorite_save", {
        genre: 1,
        id: item.id,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          if (res.data.data) {
            this.member_forumList[i].praise++;
          } else {
            this.member_forumList[i].praise--;
          }
          this.member_forumList[i].is_favorite = res.data.data;
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    lianjieClick(item) {
      const textarea = document.createElement("textarea");
      textarea.value = item.name + " " + window.location.href;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
    searchClick() {
      this.member_forumList = [];
      this.page.name = this.seachName;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    orderClick(type) {
      this.$router.push({
        path: "/user/order",
        query: {
          type,
        },
      });
    },
    shouhuohandleOk() {
      this.$post("/web/order_shou", {
        id: Number(this.member_lengthData.orderinfo.id),
      }).then((res) => {
        console.log(res);
        this.shouhuovisible = false;
        if (res.data.status) {
          this.$message.success("确认收货成功");
          this.member_lengthGet();
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
    shouhuoClick() {
      this.shouhuovisible = true;
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/web/member_forum", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        this.totalCount = res.totalCount ? res.totalCount : 0;
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.content = e.content.replace(/<[^>]*>/g, "");
            this.member_forumList.push(e);
          }
          // this.page.pageNo++;
        } else {
          // if (this.page.pageNo != 1) {
          //   this.$message.warning("已展示全部内容");
          // }
        }
      });
    },
    scrollEvent() {
      // let top = document.querySelector("#ysCont").scrollTop;
      // let height = document.querySelector("#ysCont").scrollHeight;
      // let offHeight = document.querySelector("#ysCont").offsetHeight;
      // if (offHeight + top - height >= 0) {
      //   this.listGet();
      //   // 需要执行的代码
      // }
    },
    member_lengthGet() {
      this.$get("/web/member_length").then((res) => {
        if (res.orderinfo.id != 0) {
          res.orderinfo.express_content = JSON.parse(
            res.orderinfo.express_content
          );
        }
        this.member_lengthData = res;
      });
    },
    address_default_get() {
      this.$get("/web/address_default_get").then((res) => {
        this.addressInfo = res.data;
      });
    },
    get() {
      this.$get("/web/member").then((res) => {
        window.localStorage.setItem("member", JSON.stringify(res.member));
        this.info = res.member;
      });
    },
    siteJump() {
      window.open("/chuantian/user/addressCont");
    },
    shezhiShowJs() {
      this.szshow = false;
    },
    ltjump(id) {
      this.$router.push({
        path: "/wzCont",
        query: {
          id,
        },
      });
    },
    lxJump(type) {
      this.$router.push({
        path: "/guanzhu",
        query: {
          id: this.info.id,
          type,
        },
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.contentBody {
  width: 100%;
  // height: calc(100vh - 55px);
  // overflow: auto;
}
.contentBox {
  overflow: hidden;
}
.leftBox {
  width: calc(100% - 360px);
  float: left;
  border-radius: 5px;
  .userHead {
    display: flex;
    background-color: #fff;
    padding: 30px 40px;
    border-radius: 5px;
    .img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      box-sizing: border-box;
    }
    .cont {
      width: calc(100% - 280px);
      height: 100%;
      box-sizing: border-box;
      padding-left: 15px;
      .textBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          font-size: 16px;
        }
        .txtBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #9c9c9c;
          cursor: pointer;
          .xiugai {
            font-size: 12px;
          }
          .txt {
            position: relative;
            top: -1px;
            margin-left: 2px;
            font-size: 12px;
          }
        }
      }
      .dzBox {
        display: flex;
        align-items: center;
        margin-top: 2px;
        .box {
          display: flex;
          align-items: center;
          margin-right: 15px;
          .iconfont {
            font-size: 18px;
            color: #ee5f00;
          }
          .name {
            position: relative;
            top: -1px;
            color: #666666;
          }
        }
      }
      .jjTxt {
        font-size: 14px;
        margin-top: 2px;
      }
    }
    .dzCont {
      background-color: whitesmoke;
      height: 80px;
      width: 200px;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      .head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          font-size: 13px;
        }
        .iconfont {
          font-size: 12px;
          color: #888;
        }
      }
      .text {
        font-size: 12px;
        text-align: justify;
        span {
          position: relative;
          top: 2px;
          background: rgba(255, 98, 0, 0.102);
          border-radius: 4px;
          box-sizing: border-box;
          color: #ff5000;
          display: inline-block;
          font-family: PingFangSC-Medium;
          font-size: 10px;
          height: 14px;
          line-height: 14px;
          margin-right: 4px;
          text-align: center;
          -webkit-user-select: none;
          -moz-user-select: none;
          user-select: none;
          vertical-align: top;
          width: 28px;
        }
      }
    }
  }
  .wlBox {
    border-radius: 5px;
    margin-top: 10px;
    background-color: #fff;
    padding: 15px;
    .title {
      color: #11192d;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      line-height: 16px;
      margin-bottom: 24px;
      margin-top: 8px;
    }
    .cont {
      display: flex;
      align-items: center;
      .img {
        width: 96px;
        height: 96px;
        border-radius: 5px;
        overflow: hidden;
      }
      .box {
        width: calc(100% - 196px);
        height: 96px;
        padding-left: 15px;
        box-sizing: border-box;
        flex-direction: column;
        justify-content: center;
        display: flex;
        padding-right: 15px;
        .name {
          font-weight: 600;
          font-size: 16px;
          margin-bottom: 15px;
        }
      }
      .anniu {
        align-items: center;
        border: 1px solid #e5e8ec;
        border-radius: 4px;
        box-sizing: border-box;
        color: #11192d;
        cursor: pointer;
        display: flex;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        height: 32px;
        justify-content: center;
        line-height: 14px;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        width: 80px;
      }
    }
  }
  .content {
    border-radius: 5px;
    margin-top: 10px;
    background-color: #fff;
    .leftcontHead {
      height: 60px;
      border-bottom: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 37px;
      .boxs {
        display: flex;
        align-items: center;
        line-height: 60px;
      }
      .box {
        margin-right: 44px;
        height: 58px;
        cursor: pointer;

        .name {
          font-size: 16px;
        }
      }

      .on {
        border-bottom: 3px solid #f66;

        // transition: all .3s linear;
        .name {
          font-weight: 700;
        }
      }
      .inpBox {
        width: 220px;
        border-radius: 35px;
        height: 35px;
        border: 1px solid #f66;
        position: relative;
        color: #f66;
        overflow: hidden;
        margin-right: 15px;
        input {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding-left: 15px;
          color: #f66;
        }
        .ssBox {
          top: 0;
          right: 0;
          height: 100%;
          width: 30px;
          line-height: 35px;
          font-size: 18px;
          position: absolute;
          cursor: pointer;
        }
      }
    }
    .contList {
      padding: 0 20px;
      .cont {
        padding: 20px 0 15px;
        border-bottom: 1px solid #ededed;

        .contHead {
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 13px;

          .fbBox {
            display: flex;
            align-items: center;
            flex: 1;

            .phoimg {
              width: 40px;
              height: 40px;

              img {
                object-fit: cover;
                border-radius: 50%;
              }
            }

            .name {
              color: #505766;
              margin-left: 10px;
            }

            .txt {
              padding: 0 6px;
              font-size: 12px;
              line-height: 16px;
              font-weight: 600;
              margin-right: 8px;
              border: 1px solid #fb9900;
              color: #fb9900;
              border-radius: 2px;
              margin-left: 15px;
            }

            .txtlan {
              color: #7b8aff;
              border: 1px solid #7b8aff;
            }
          }

          .lxBox {
            display: flex;
            align-items: center;

            .box {
              padding: 0 12px;
              line-height: 28px;
              font-weight: 500;
              color: #333;
              text-align: center;
              font-size: 12px;
              border-radius: 4px;
              background: #eff9ff;
              margin-left: 16px;
              position: relative;
              cursor: pointer;
              display: flex;
              align-items: center;

              .yuan {
                border-radius: 50%;
                height: 20px;
                width: 20px;
                background: linear-gradient(to right, #00abee, #55c6f3);
                font-weight: 600;
                color: #fff;
                font-size: 14px;
                margin-right: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .yuanimg {
                border-radius: 50%;
                height: 20px;
                width: 20px;
                font-weight: 600;
                color: #fff;
                font-size: 14px;
                margin-right: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }

            .hongb {
              background-color: #ffefef;
              color: #ee0000;
            }
          }
        }

        .contTitle {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          line-height: 22px;
          margin-bottom: 12px;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          span {
            margin-top: 1px;
            width: 36px;
            text-align: center;
            display: inline-block;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            font-weight: 600;
            margin-right: 8px;
            color: #fff;
            // background: #ff7a7a;
            background: #fb9900;
            position: relative;
            top: -1px;
            border-radius: 2px;
          }
        }

        .contText {
          color: #666;
          cursor: pointer;
        }

        .funBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #999;
          margin-top: 5px;

          .boxs {
            display: flex;

            .box {
              display: flex;
              align-items: center;
              margin-right: 15px;
              position: relative;
              .browse {
                font-size: 18px;
              }

              .message {
                font-size: 16px;
              }

              .praise {
                font-size: 16px;
              }
              .on {
                color: rgb(233, 14, 14);
              }

              .send {
                font-size: 16px;
              }

              .num {
                position: relative;
                top: -1px;
                font-size: 12px;
                margin-left: 2px;
              }
              .fxBox {
                position: absolute;
                top: 0;
                right: -100px;
                box-shadow: 0 0 4px 2px #ebebeb;
                background-color: #fff;
                display: none;
                width: 105px;
                border-radius: 5px;
                justify-content: center;
                align-items: center;
                height: 40px;
                .lianjieBox {
                  color: #fff;
                  background-color: #f56709;
                  border-radius: 50%;
                  height: 20px;
                  width: 20px;
                  margin-right: 5px;
                  .lianjie {
                    font-size: 12px;
                  }
                }
              }
            }
            .box:last-child {
              cursor: pointer;
            }
            .box:hover {
              .fxBox {
                display: flex;
              }
            }
          }
        }
      }
    }
  }
}
.ritBox1 {
  float: left;
  width: 360px;
  box-sizing: border-box;
  padding-left: 10px;
  .content {
    background-color: #fff;
    border-radius: 5px;
    margin-bottom: 10px;
    .contHead {
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebebeb;
      padding: 0 15px;
      .img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #7b8aff;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
        .iconfont {
          font-size: 12px;
        }
      }
      .huang {
        background-color: #ffc67b;
      }
      .lv {
        background-color: #0bb822;
      }
    }
    .cont {
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;
      padding: 28px 0 13px;
      .box {
        text-align: center;
        cursor: pointer;
        min-width: 33.33%;
        margin-bottom: 15px;
        .num {
          font-weight: 600;
          font-size: 24px;
        }
        .name {
          font-size: 12px;
          color: #666;
        }
      }
    }
  }
}
</style>
